import { object, string } from "yup";
import PageBlock from "@page-js/Pages/Page/Editor/scripts/pageBlock";

export default class BusinessHours extends PageBlock {
  public getType(): string {
    return "BusinessHours";
  }

  protected init(): any {
    return {
      props: {
        title: "영업시간",
        weekday: {
          start: "09:00",
          end: "21:00",
        },
        weekend: {
          start: "10:00",
          end: "20:00",
        },
        breakTime: {
          start: "15:00",
          end: "16:00",
        },
      },
      attrs: {},
    };
  }

  public validateOrThrow(): Promise<any> {
    const timePattern = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;

    const schema = object().shape({
      props: object()
        .shape({
          weekday: object()
            .shape({
              start: string().matches(timePattern, "올바른 시간 형식이 아닙니다").required().label("평일 시작 시간"),
              end: string().matches(timePattern, "올바른 시간 형식이 아닙니다").required().label("평일 종료 시간"),
            })
            .required()
            .label("평일"),
          weekend: object()
            .shape({
              start: string().matches(timePattern, "올바른 시간 형식이 아닙니다").required().label("주말 시작 시간"),
              end: string().matches(timePattern, "올바른 시간 형식이 아닙니다").required().label("주말 종료 시간"),
            })
            .required()
            .label("주말"),
          breakTime: object()
            .shape({
              start: string().matches(timePattern, "올바른 시간 형식이 아닙니다").required().label("휴식 시작 시간"),
              end: string().matches(timePattern, "올바른 시간 형식이 아닙니다").required().label("휴식 종료 시간"),
            })
            .required()
            .label("휴식 시간"),
        })
        .label("옵션"),
      attrs: object().required().label("속성"),
    });

    return schema.validate(this.toJSON(), { abortEarly: false });
  }
}
